import IconAsBgImage from "../IconAsBgImage";

const RaychatLogo = ({ pureSvg, className, color, size }) => {
  const svg = (
    <svg
      width="75"
      height="75"
      viewBox="0 0 75 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 37.4979C0 3.08453 12.5015 0 37.5012 0C62.5009 0 74.9991 3.74812 74.9991 37.4979C74.9991 71.7779 62.5009 74.9958 37.5012 74.9958C12.5015 74.9958 0 70.3206 0 37.4979Z"
        fill="#841474"
      />
      <path
        d="M60.2709 36.3765C60.2743 31.989 59.01 27.6938 56.6303 24.0077C54.2505 20.3216 50.8565 17.4015 46.8565 15.5985C42.8565 13.7955 38.4208 13.1864 34.0829 13.8446C29.745 14.5027 25.6896 16.4 22.4043 19.3083C19.1191 22.2165 16.744 26.0119 15.5646 30.238C14.3853 34.4641 14.4519 38.9409 15.7565 43.1301C17.0611 47.3192 19.548 51.0423 22.9183 53.8515C26.2886 56.6607 30.3987 58.4365 34.7543 58.9653V67.7854L51.5608 54.2635C51.7809 54.0934 52.001 53.93 52.2278 53.7399L52.828 53.2597H52.758C55.1254 51.1308 57.0179 48.5271 58.3123 45.6182C59.6068 42.7093 60.2741 39.5604 60.2709 36.3765ZM37.6788 49.2215C35.9987 49.2248 34.3345 48.8959 32.7819 48.2538C31.2293 47.6117 29.819 46.6691 28.632 45.4801L30.8928 43.2192C32.6933 45.0162 35.1333 46.0255 37.6771 46.0255C40.221 46.0255 42.6609 45.0162 44.4614 43.2192L46.7223 45.4801C45.5358 46.6688 44.126 47.6114 42.574 48.2534C41.022 48.8955 39.3584 49.2245 37.6788 49.2215Z"
        fill="white"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsBgImage {...{ svg, className, color, size }} />;
};

export default RaychatLogo;
